import Reveal from "@/components/feature/Reveal";
import { LINKS, WA_LINKS } from "@/constants/site";

export default function Contact() {
  return (
    <section id="contacto" className="w-full bg-cream py-14 md:py-24">
      <div className="mx-auto w-full max-w-3xl px-4 text-center md:px-6">
        <Reveal>
          <h2 className="font-serif text-4xl text-darktext md:text-6xl">Escríbenos</h2>
          <p className="mx-auto mt-5 max-w-xl text-base leading-relaxed text-darktext/80 md:text-lg">
            Escríbenos por WhatsApp para reservar, resolver tus dudas o contarnos qué vas a
            celebrar.
          </p>

          <a
            href={WA_LINKS.info}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-8 inline-flex min-h-[56px] w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-wa px-8 text-base font-semibold text-white transition-colors hover:bg-[#1ebe5b] sm:w-auto"
          >
            <i className="ri-whatsapp-fill text-xl" aria-hidden="true" />
            Escribir por WhatsApp
          </a>

          <div className="mt-7 flex justify-center">
            <a
              href={LINKS.instagramClem}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 whitespace-nowrap text-base font-semibold text-darktext underline decoration-malva decoration-2 underline-offset-4 transition-colors hover:text-malva"
            >
              <i className="ri-instagram-line text-xl" aria-hidden="true" />
              @clembyceron
            </a>
          </div>

          <p className="mx-auto mt-8 max-w-xl text-xs leading-relaxed text-darktext/70 md:text-sm">
            Si tienes alguna alergia o intolerancia, nuestros asesores gastronómicos te darán
            información según los alimentos que no puedas consumir.
          </p>
        </Reveal>
      </div>
    </section>
  );
}